import {browserHistory} from 'react-router'
import axios from 'axios'
import qs from 'qs'
import {getJsonFromUrl, getAccessToken} from "../../utils";
import Config from '../../config'

export default class WKPgyCheck {
    static jwt_token = ''
    static role = 1 // 1 普通 2 达人 3 大使
    static urlParams = getJsonFromUrl()
    static isFromPgy = WKPgyCheck.urlParams.st && WKPgyCheck.urlParams.st.indexOf('pgy') > -1

    static checkPGYMall(id, type) {
        let access_token = getAccessToken()
        this.jwt_token = access_token

        if (window.location.host !== 'dbg.weike.fm') {
            return this.getMallAccess(id, type, access_token)
        }
    }

    static getMallAccess(id, type, access_token) {
        let query = browserHistory.getCurrentLocation().query
        let params = {product_type: type, product_id: id}
        let api = `/index/product_config`
        // {role, dist_money}
        return window.axiosPgy.get(api, {
            params: {...query, ...params},
            headers: {Token: access_token}
        })
    }

    static subscribe(id, type) {
        return window.axiosPgy.post(
            `/index/subscribe_product`,
            qs.stringify({product_type: type, product_id: id}),
            {headers: {
                Token: this.jwt_token
            }}
        )
    }

    static resell(liveroomId, id, type) {
        return window.axiosAdmin.get(`/api/liverooms/${liveroomId}/config/pgyadd`, {
            params: {
                token: this.jwt_token,
                object_id: id,
                object_type: type
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/wk/WKPgyCheck.js